const API_URL = process.env.REACT_APP_API_URL || '';

const authHeaders = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('userToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function uploadReviewPhotos(reviewId, files) {
  const fd = new FormData();
  for (const f of files) fd.append('photos', f);
  const res = await fetch(`${API_URL}/api/reviews/${reviewId}/photos`, {
    method: 'POST',
    headers: authHeaders(),
    body: fd,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Upload failed');
  }
  return res.json();
}

export async function deleteReviewPhoto(reviewId, publicId) {
  const encoded = encodeURIComponent(publicId);
  const res = await fetch(`${API_URL}/api/reviews/${reviewId}/photos/${encoded}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error('Delete failed');
  return res.json();
}

export async function fetchSpotlightReviews(limit = 12) {
  const res = await fetch(`${API_URL}/api/reviews/spotlight?limit=${limit}`);
  if (!res.ok) throw new Error('Failed to load spotlight');
  return res.json();
}

export async function voteHelpful(reviewId) {
  const res = await fetch(`${API_URL}/api/reviews/${reviewId}/helpful`, {
    method: 'POST',
  });
  if (res.status === 429) throw new Error('Already voted today');
  if (!res.ok) throw new Error('Vote failed');
  return res.json();
}

export async function toggleSpotlight(reviewId, isSpotlight, spotlightOrder) {
  const res = await fetch(`${API_URL}/api/admin/reviews/${reviewId}/spotlight`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ isSpotlight, spotlightOrder }),
  });
  if (!res.ok) throw new Error('Toggle failed');
  return res.json();
}

export async function fetchAboutJyoti() {
  const res = await fetch(`${API_URL}/api/about-jyoti`);
  if (!res.ok) throw new Error('Failed');
  return res.json();
}

// Stub for legacy /api/config/trust endpoint (returns null so callers fall back to defaults)
// TODO: remove import sites that reference fetchTrustConfig and delete this stub
export async function fetchTrustConfig() {
  return null;
}
